var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shici-container" },
    [
      _c("header", { staticClass: "scroll-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "header-sub" },
          [
            _vm._v("\n      拾字成句 · 积句成篇 —— jmdvirus\n      "),
            _c(
              "router-link",
              { staticClass: "game-link", attrs: { to: "/shicigame" } },
              [_vm._v("诗词游戏")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-section" },
        [
          _c("el-input", {
            staticClass: "search-input",
            attrs: {
              placeholder: "搜索标题 / 作者 / 诗句",
              "prefix-icon": "el-icon-search",
              clearable: "",
            },
            on: { input: _vm.onSearch },
            model: {
              value: _vm.searchKeyword,
              callback: function ($$v) {
                _vm.searchKeyword = $$v
              },
              expression: "searchKeyword",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-select",
              attrs: { placeholder: "按标题筛选", clearable: "" },
              on: { change: _vm.onCategoryChange },
              model: {
                value: _vm.selectedCategory,
                callback: function ($$v) {
                  _vm.selectedCategory = $$v
                },
                expression: "selectedCategory",
              },
            },
            [
              _c("el-option", { attrs: { label: "全部诗词", value: "" } }),
              _vm._v(" "),
              _vm._l(_vm.categories, function (category) {
                return _c("el-option", {
                  key: category,
                  attrs: { label: category, value: category },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sort-toggle" },
            _vm._l(_vm.sortOptions, function (opt) {
              return _c(
                "button",
                {
                  key: opt.value,
                  class: { "is-active": _vm.sortOrder === opt.value },
                  on: {
                    click: function ($event) {
                      _vm.sortOrder = opt.value
                    },
                  },
                },
                [_vm._v(_vm._s(opt.label))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("span", { staticClass: "stats-text" }, [
            _vm._v("库中共 " + _vm._s(_vm.total) + " 首"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayItems.length
        ? _c(
            "div",
            { staticClass: "timeline" },
            _vm._l(_vm.timelineMonthGroups, function (group) {
              return _c(
                "section",
                { key: group.year, staticClass: "year-group" },
                [
                  _c("div", { staticClass: "year-head" }, [
                    _c("span", { staticClass: "year-cn" }, [
                      _vm._v(_vm._s(group.cn)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "year-num" }, [
                      _vm._v(_vm._s(group.year)),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "year-rule" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "year-items" },
                    _vm._l(group.months, function (month) {
                      return _c(
                        "div",
                        { key: month.key, staticClass: "month-group" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "month-head",
                              attrs: { id: month.anchor },
                            },
                            [
                              _c("span", { staticClass: "month-label" }, [
                                _vm._v(
                                  _vm._s(_vm.monthToCn(month.month)) + "月"
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(month.items, function (item, idx) {
                            return _c(
                              "article",
                              {
                                key: item.title + "-" + item.createTime,
                                staticClass: "timeline-item",
                                style: {
                                  animationDelay: Math.min(idx, 8) * 70 + "ms",
                                },
                              },
                              [
                                _c("div", { staticClass: "item-side" }, [
                                  _c("span", { staticClass: "item-date" }, [
                                    _vm._v(_vm._s(_vm.formatDay(item))),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "item-time" }, [
                                    _vm._v(_vm._s(_vm.formatClock(item))),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "poem-card",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDetail(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("h3", { staticClass: "poem-title" }, [
                                      _vm._v(_vm._s(item.title)),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "poem-author" }, [
                                      _c(
                                        "span",
                                        { staticClass: "author-mark" },
                                        [_vm._v("〔")]
                                      ),
                                      _vm._v(_vm._s(item.author)),
                                      _c(
                                        "span",
                                        { staticClass: "author-mark" },
                                        [_vm._v("〕")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "poem-content" },
                                      _vm._l(
                                        _vm
                                          .formatContent(item.content)
                                          .slice(0, 4),
                                        function (line, lineIdx) {
                                          return _c(
                                            "p",
                                            {
                                              key: lineIdx,
                                              staticClass: "poem-line",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(line) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "card-footer" }, [
                                      _c("span", { staticClass: "poem-time" }, [
                                        _vm._v(_vm._s(item.createtime)),
                                      ]),
                                      _vm._v(" "),
                                      _vm._m(1, true),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tocVisible && _vm.displayItems.length
        ? _c("div", { staticClass: "toc-panel" }, [
            _c("div", { staticClass: "toc-head" }, [
              _c("span", { staticClass: "toc-title" }, [_vm._v("目录")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "toc-close",
                  on: {
                    click: function ($event) {
                      _vm.tocVisible = false
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-close" })]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { ref: "tocBody", staticClass: "toc-body" },
              _vm._l(_vm.timelineMonthGroups, function (g) {
                return _c(
                  "div",
                  { key: g.year, staticClass: "toc-year" },
                  [
                    _c("div", { staticClass: "toc-year-label" }, [
                      _c("span", { staticClass: "toc-year-num" }, [
                        _vm._v(_vm._s(g.year)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "toc-year-cn" }, [
                        _vm._v(_vm._s(g.cn)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(g.months, function (m) {
                      return _c(
                        "a",
                        {
                          key: m.key,
                          staticClass: "toc-month",
                          class: { "is-active": _vm.activeAnchor === m.anchor },
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function ($event) {
                              return _vm.scrollToAnchor(m.anchor)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              m.month ? _vm.monthToCn(m.month) + "月" : "未署"
                            )
                          ),
                          _c("i", [_vm._v(_vm._s(m.items.length))]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ])
        : _vm.displayItems.length
        ? _c(
            "button",
            {
              staticClass: "toc-fab",
              on: {
                click: function ($event) {
                  _vm.tocVisible = true
                },
              },
            },
            [_vm._v("目录")]
          )
        : !_vm.isLoading
        ? _c("div", { staticClass: "empty-tip" }, [
            _c("span", { staticClass: "empty-seal" }, [_vm._v("寻")]),
            _vm._v(" "),
            _c("p", [_vm._v("卷中未见此篇")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMore
        ? _c("div", { staticClass: "load-more-section" }, [
            _c(
              "button",
              {
                staticClass: "load-more-btn",
                class: { "is-loading": _vm.isLoading },
                on: { click: _vm.queryShici },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.isLoading ? "展卷中…" : "再展一卷") +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "poem-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: "620px",
            center: "",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.selectedPoem
            ? _c("div", { staticClass: "dialog-content" }, [
                _c(
                  "button",
                  {
                    staticClass: "dialog-close",
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = false
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-close" })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "dialog-seal" }, [
                  _vm._v(_vm._s((_vm.selectedPoem.author || "佚")[0])),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "dialog-title" }, [
                  _vm._v(_vm._s(_vm.selectedPoem.title)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "dialog-author" }, [
                  _vm._v("〔 " + _vm._s(_vm.selectedPoem.author) + " 〕"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dialog-divider" }, [_c("i")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog-poem" },
                  _vm._l(
                    _vm.formatContent(_vm.selectedPoem.content),
                    function (line, idx) {
                      return _c("p", { key: idx, staticClass: "dialog-line" }, [
                        _vm._v("\n          " + _vm._s(line) + "\n        "),
                      ])
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dialog-divider" }, [_c("i")]),
                _vm._v(" "),
                _c("p", { staticClass: "dialog-time" }, [
                  _vm._v("收录于 " + _vm._s(_vm.selectedPoem.createtime)),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-inner" }, [
      _c("h1", { staticClass: "header-title" }, [_vm._v("资深小白的诗词世界")]),
      _vm._v(" "),
      _c("span", { staticClass: "header-seal" }, [_vm._v("诗")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "view-detail" }, [
      _vm._v("展开全篇"),
      _c("i", { staticClass: "el-icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }